import {
  PodSecurityStandardsFormValues,
  PodSecurityStandardsPolicyPayload,
} from './types';

/**
 * Builds the API payload from form data, dropping rows without a namespace name
 * (empty new rows) and trimming namespace names.
 */
export function buildPodSecurityStandardsPayload(
  formData: PodSecurityStandardsFormValues
): PodSecurityStandardsPolicyPayload {
  const namespaces = (formData.namespaces || [])
    .map((entry) => ({ ...entry, namespace: entry.namespace.trim() }))
    .filter((entry) => entry.namespace !== '');

  return { namespaces };
}
